const translate = {
  image: {
    single_upload: {
      en: 'Upload Image',
      es: 'Subir Imagen',
      fr: "Télécharger l'image",
      de: 'Bild hochladen',
      pt: 'Carregar Imagem',
      pl: 'Prześlij obraz',
      nl: 'Afbeelding uploaden',
      el: 'Μεταφόρτωση εικόνας',
      cs: 'Nahrát obrázek',
      sv: 'Ladda upp bild',
      hu: 'Kép feltöltése',
      da: 'Upload billede',
      fi: 'Lataa kuva',
      sk: 'Nahrať obrázok',
      bg: 'Качване на изображение',
      hr: 'Prenesi sliku',
      lt: 'Įkelti vaizdą',
      lv: 'Augšupielādēt attēlu',
      et: 'Laadi pilt üles',
      sl: 'Naloži sliko',
      ga: 'Uaslódáil Íomhá',
      mt: "Ittella' Immaġni",
      cy: 'Llwytho Delwedd',
      ro: 'Încărcați imaginea',
      it: 'Carica immagine',
      zh_cn: '上传图片',
      hi: 'छवि अपलोड करें',
      ar: 'تحميل صورة',
      bn: 'ছবি আপলোড করুন',
      ru: 'Загрузить изображение',
      ja: '画像をアップロード',
      tr: 'Resim Yükle',
      ko: '이미지 업로드',
      vi: 'Tải hình ảnh lên',
      id: 'Unggah gambar',
      th: 'อัปโหลดรูปภาพ',
      ms: 'Muat naik imej',
      ar_eg: 'تحميل صورة',
      uk: 'Завантажити зображення',
    },
    multiple_upload: {
      en: 'Upload Images',
      es: 'Subir Imágenes',
      fr: 'Télécharger des images',
      de: 'Bilder hochladen',
      pt: 'Carregar Imagens',
      pl: 'Prześlij obrazy',
      nl: 'Afbeeldingen uploaden',
      el: 'Μεταφόρτωση εικόνων',
      cs: 'Nahrát obrázky',
      sv: 'Ladda upp bilder',
      hu: 'Képek feltöltése',
      da: 'Upload billeder',
      fi: 'Lataa kuvia',
      sk: 'Nahrať obrázky',
      bg: 'Качване на изображения',
      hr: 'Prenesi slike',
      lt: 'Įkelti vaizdus',
      lv: 'Augšupielādēt attēlus',
      et: 'Laadi pildid üles',
      sl: 'Naloži slike',
      ga: 'Uaslódáil Íomhánna',
      mt: "Ittella' Immaġini",
      cy: 'Llwytho Delweddau',
      ro: 'Încărcați imaginile',
      it: 'Carica immagini',
      zh_cn: '上传图片',
      hi: 'छवियाँ अपलोड करें',
      ar: 'تحميل الصور',
      bn: 'ছবিগুলি আপলোড করুন',
      ru: 'Загрузить изображения',
      ja: '画像をアップロード',
      tr: 'Resimler Yükle',
      ko: '이미지 업로드',
      vi: 'Tải hình ảnh lên',
      id: 'Unggah gambar',
      th: 'อัปโหลดรูปภาพ',
      ms: 'Muat naik imej',
      ar_eg: 'تحميل الصور',
      uk: 'Завантажити зображення',
    },
    replace: {
      en: 'Replace Image',
      es: 'Reemplazar Imagen',
      fr: "Remplacer l'image",
      de: 'Bild ersetzen',
      pt: 'Substituir Imagem',
      pl: 'Zastąp obraz',
      nl: 'Afbeelding vervangen',
      el: 'Αντικατάσταση εικόνας',
      cs: 'Nahradit obrázek',
      sv: 'Ersätt bild',
      hu: 'Kép cseréje',
      da: 'Erstat billede',
      fi: 'Korvaa kuva',
      sk: 'Nahradiť obrázok',
      bg: 'Замяна на изображението',
      hr: 'Zamijeni sliku',
      lt: 'Pakeisti vaizdą',
      lv: 'Aizstāt attēlu',
      et: 'Asenda pilt',
      sl: 'Zamenjaj sliko',
      ga: 'Ionadaigh Íomhá',
      mt: 'Ibdel l-Immaġni',
      cy: 'Amnewid Delwedd',
      ro: 'Înlocuiți imaginea',
      it: 'Sostituisci immagine',
      zh_cn: '替换图片',
      hi: 'छवि बदलें',
      ar: 'استبدال الصورة',
      bn: 'ছবি প্রতিস্থাপন করুন',
      ru: 'Заменить изображение',
      ja: '画像を置き換える',
      tr: 'Resmi Değiştir',
      ko: '이미지 교체',
      vi: 'Thay thế hình ảnh',
      id: 'Ganti gambar',
      th: 'แทนที่รูปภาพ',
      ms: 'Gantikan imej',
      ar_eg: 'استبدال الصورة',
      uk: 'Замінити зображення',
    },
    hint: {
      en: 'Upload JPG image, Max size of 800K',
      es: 'Subir imagen JPG, Tamaño máximo de 800K',
      fr: 'Télécharger une image JPG, Taille maximale de 800K',
      de: 'JPG-Bild hochladen, Maximalgröße 800K',
      pt: 'Carregar imagem JPG, Tamanho máximo de 800K',
      pl: 'Prześlij obraz JPG, Maksymalny rozmiar 800K',
      nl: 'Upload JPG-afbeelding, Maximale grootte van 800K',
      el: 'Μεταφόρτωση εικόνας JPG, Μέγιστο μέγεθος 800K',
      cs: 'Nahrát obrázek JPG, Maximální velikost 800K',
      sv: 'Ladda upp JPG-bild, Maxstorlek 800K',
      hu: 'JPG kép feltöltése, Max méret 800K',
      da: 'Upload JPG-billede, Maksimal størrelse 800K',
      fi: 'Lataa JPG-kuva, Maksimikoko 800K',
      sk: 'Nahrať obrázok JPG, Maximálna veľkosť 800K',
      bg: 'Качване на JPG изображение, Максимален размер 800K',
      hr: 'Prenesi JPG sliku, Maksimalna veličina 800K',
      lt: 'Įkelkite JPG vaizdą, Maksimalus dydis 800K',
      lv: 'Augšupielādējiet JPG attēlu, Maksimālais izmērs 800K',
      et: 'Laadi JPG-pilt üles, Maksimaalne suurus 800K',
      sl: 'Naloži JPG sliko, Največja velikost 800K',
      ga: 'Uaslódáil íomhá JPG, Méid uasta 800K',
      mt: "Ittella' immaġni JPG, Daqs massimu ta' 800K",
      cy: 'Llwytho delwedd JPG, Maint mwyaf 800K',
      ro: 'Încărcați imagine JPG, Dimensiune maximă de 800K',
      it: 'Carica immagine JPG, Dimensione massima di 800K',
      zh_cn: '上传 JPG 图片, 最大大小为 800K',
      hi: 'JPG छवि अपलोड करें, अधिकतम आकार 800K',
      ar: 'تحميل صورة JPG، الحد الأقصى للحجم 800K',
      bn: 'JPG ছবি আপলোড করুন, সর্বাধিক আকার 800K',
      ru: 'Загрузить JPG изображение, Максимальный размер 800K',
      ja: 'JPG画像をアップロード、最大サイズは800K',
      tr: 'JPG resim yükleyin, Maksimum boyut 800K',
      ko: 'JPG 이미지 업로드, 최대 크기 800K',
      vi: 'Tải hình ảnh JPG lên, Kích thước tối đa 800K',
      id: 'Unggah gambar JPG, Ukuran maksimum 800K',
      th: 'อัปโหลดภาพ JPG, ขนาดสูงสุด 800K',
      ms: 'Muat naik imej JPG, Saiz maksimum 800K',
      ar_eg: 'تحميل صورة JPG، الحد الأقصى للحجم 800K',
      uk: 'Завантажте зображення JPG, Максимальний розмір 800K',
    },
    error: {
      en: 'Invalid Image Format or Size!\n Please upload in JPG format and under size limit 800K',
      es: '¡Formato o tamaño de imagen no válido!\n Por favor, sube una imagen en formato JPG y dentro del límite de tamaño de 800K',
      fr: "Format ou taille d'image invalide!\n Veuillez télécharger une image au format JPG et dans la limite de taille de 800K",
      de: 'Ungültiges Bildformat oder Größe!\n Bitte laden Sie das Bild im JPG-Format und unter der Größenbeschränkung von 800K hoch',
      pt: 'Formato ou tamanho de imagem inválido!\n Por favor, carregue uma imagem no formato JPG e com tamanho inferior a 800K',
      pl: 'Nieprawidłowy format lub rozmiar obrazu!\n Prześlij obraz w formacie JPG i poniżej limitu rozmiaru 800K',
      nl: 'Ongeldig afbeeldingsformaat of -grootte!\n Upload een JPG-afbeelding onder de grootte van 800K',
      el: 'Μη έγκυρη μορφή ή μέγεθος εικόνας!\n Παρακαλώ ανεβάστε σε μορφή JPG και εντός του ορίου μεγέθους 800K',
      cs: 'Neplatný formát nebo velikost obrázku!\n Nahrajte prosím obrázek ve formátu JPG a pod velikostní limit 800K',
      sv: 'Ogiltigt bildformat eller storlek!\n Ladda upp en bild i JPG-format och under storleksgränsen 800K',
      hu: 'Érvénytelen képformátum vagy méret!\n Kérjük, töltsön fel JPG formátumú képet 800K méretkorlát alatt',
      da: 'Ugyldigt billedformat eller størrelse!\n Upload venligst i JPG-format og under størrelsesgrænsen på 800K',
      fi: 'Virheellinen kuvan formaatti tai koko!\n Lataa JPG-muodossa oleva kuva, joka on alle 800K',
      sk: 'Neplatný formát alebo veľkosť obrázka!\n Nahrajte obrázok vo formáte JPG a do veľkostného limitu 800K',
      bg: 'Невалиден формат или размер на изображението!\n Моля, качете изображение във формат JPG и с размер до 800K',
      hr: 'Nevažeći format slike ili veličina!\n Molimo prenesite sliku u JPG formatu i ispod ograničenja veličine od 800K',
      lt: 'Netinkamas vaizdo formatas arba dydis!\n Įkelkite JPG formato vaizdą ir mažesnį nei 800K',
      lv: 'Nederīgs attēla formāts vai izmērs!\n Lūdzu, augšupielādējiet JPG formātā un ievērojiet 800K izmēra ierobežojumu',
      et: 'Vigane pildi formaat või suurus!\n Palun laadige üles JPG-vormingus pilt, mis on väiksem kui 800K',
      sl: 'Neveljaven format slike ali velikost!\n Prosimo, naložite sliko v JPG formatu in pod omejitvijo velikosti 800K',
      ga: 'Formáid nó méid íomhá neamhbhailí!\n Uaslódáil i bhformáid JPG agus faoi theorainn mhéide 800K le do thoil',
      mt: "Format jew daqs tal-immaġni invalidu!\n Jekk jogħġbok ittella' immaġni f'format JPG u taħt il-limitu ta' daqs ta' 800K",
      cy: 'Fformat neu faint delwedd annilys!\n Llwythwch i fyny mewn fformat JPG a dan y terfyn maint o 800K',
      ro: 'Format sau dimensiune imagine nevalidă!\n Vă rugăm să încărcați o imagine în format JPG și sub limita de dimensiune de 800K',
      it: "Formato o dimensione dell'immagine non valido!\n Carica un'immagine in formato JPG e sotto il limite di 800K",
      zh_cn: '图片格式或大小无效！\n 请上传JPG格式，且大小低于800K',
      hi: 'अमान्य छवि प्रारूप या आकार!\n कृपया JPG प्रारूप में छवि अपलोड करें और 800K के आकार सीमा के भीतर',
      ar: 'تنسيق الصورة أو الحجم غير صالح!\n يرجى تحميل صورة بتنسيق JPG وضمن الحد الأقصى للحجم 800K',
      bn: 'অবৈধ ছবি ফরম্যাট বা আকার!\n অনুগ্রহ করে JPG ফরম্যাটে এবং 800K আকারের সীমার মধ্যে আপলোড করুন',
      ru: 'Неверный формат изображения или размер!\n Пожалуйста, загрузите изображение в формате JPG и меньше 800K',
      ja: '無効な画像フォーマットまたはサイズです！\n JPGフォーマットでサイズ制限800K以内でアップロードしてください',
      tr: "Geçersiz Resim Formatı veya Boyutu!\n Lütfen JPG formatında ve boyut sınırı 800K'nın altında yükleyin",
      ko: '유효하지 않은 이미지 형식 또는 크기입니다!\n JPG 형식으로 업로드하고 크기는 800K 이하로 해주세요',
      vi: 'Định dạng hoặc kích thước hình ảnh không hợp lệ!\n Vui lòng tải lên ở định dạng JPG và dưới giới hạn kích thước 800K',
      id: 'Format atau ukuran gambar tidak valid!\n Harap unggah dalam format JPG dan di bawah batas ukuran 800K',
      th: 'รูปแบบหรือขนาดรูปภาพไม่ถูกต้อง!\n กรุณาอัปโหลดในรูปแบบ JPG และต่ำกว่าขีดจำกัดขนาด 800K',
      ms: 'Format atau saiz imej tidak sah!\n Sila muat naik dalam format JPG dan di bawah had saiz 800K',
      ar_eg: 'تنسيق الصورة أو الحجم غير صالح!\n يرجى تحميل الصورة بتنسيق JPG وأقل من 800K',
      uk: 'Недійсний формат або розмір зображення!\n Завантажте зображення у форматі JPG та менше 800K',
    },
    alert: {
      en: 'Note: To change a slider image, delete the existing one and upload a new image',
      es: 'Nota: Para cambiar una imagen del carrusel, elimina la existente y sube una nueva imagen',
      fr: "Remarque : Pour changer une image du diaporama, supprimez l'image existante et téléchargez-en une nouvelle",
      de: 'Hinweis: Um ein Slider-Bild zu ändern, löschen Sie das vorhandene Bild und laden Sie ein neues Bild hoch',
      pt: 'Nota: Para mudar uma imagem do slider, exclua a existente e carregue uma nova imagem',
      pl: 'Uwaga: Aby zmienić obraz w suwaku, usuń istniejący i prześlij nowy obraz',
      nl: 'Opmerking: Om een schuifafbeelding te wijzigen, verwijder de bestaande afbeelding en upload een nieuwe',
      el: 'Σημείωση: Για να αλλάξετε μια εικόνα ολισθητήρα, διαγράψτε την υπάρχουσα και ανεβάστε μια νέα εικόνα',
      cs: 'Poznámka: Chcete-li změnit obrázek posuvníku, smažte stávající obrázek a nahrajte nový',
      sv: 'Obs: För att ändra en bild i bildspelet, ta bort den befintliga och ladda upp en ny bild',
      hu: 'Megjegyzés: A csúszka képének módosításához törölje a meglévőt, és töltsön fel egy újat',
      da: 'Bemærk: For at ændre et skyderbillede skal du slette det eksisterende og uploade et nyt billede',
      fi: 'Huomautus: Vaihtaaksesi liukukuvan poista nykyinen ja lataa uusi kuva',
      sk: 'Poznámka: Ak chcete zmeniť obrázok posúvača, odstráňte existujúci a nahrajte nový obrázok',
      bg: 'Забележка: За да промените изображение на плъзгач, изтрийте съществуващото и качете ново изображение',
      hr: 'Napomena: Da biste promijenili sliku klizača, izbrišite postojeću i prenesite novu sliku',
      lt: 'Pastaba: Norėdami pakeisti slankiklio vaizdą, ištrinkite esamą ir įkelkite naują vaizdą',
      lv: 'Piezīme: Lai nomainītu slīdera attēlu, izdzēsiet esošo un augšupielādējiet jaunu attēlu',
      et: 'Märkus: Liugpildi muutmiseks kustutage olemasolev pilt ja laadige üles uus',
      sl: 'Opomba: Če želite spremeniti sliko drsnika, izbrišite obstoječo in naložite novo sliko',
      ga: 'Nóta: Chun íomhá sleamhnáin a athrú, scrios an ceann atá ann cheana féin agus uaslódáil íomhá nua',
      mt: "Nota: Biex tibdel immaġni tal-slider, ħassar dik eżistenti u ittella' waħda ġdida",
      cy: "Nodyn: I newid delwedd sleid, dileu'r un bresennol a llwytho delwedd newydd i fyny",
      ro: 'Notă: Pentru a schimba o imagine glisantă, ștergeți-o pe cea existentă și încărcați una nouă',
      it: "Nota: Per cambiare un'immagine del cursore, elimina l'immagine esistente e caricane una nuova",
      zh_cn: '注意：要更改滑块图像，请删除现有图像并上传新图像',
      hi: 'नोट: स्लाइडर छवि बदलने के लिए, मौजूदा छवि हटाएं और नई छवि अपलोड करें',
      ar: 'ملاحظة: لتغيير صورة المنزلق، احذف الصورة الحالية وقم بتحميل صورة جديدة',
      bn: 'বিঃদ্রঃ: একটি স্লাইডার ইমেজ পরিবর্তন করতে, বিদ্যমানটি মুছে ফেলুন এবং একটি নতুন ছবি আপলোড করুন',
      ru: 'Примечание: Чтобы изменить изображение слайдера, удалите существующее и загрузите новое изображение',
      ja: '注: スライダー画像を変更するには、既存の画像を削除して新しい画像をアップロードしてください',
      tr: 'Not: Bir slider görüntüsünü değiştirmek için, mevcut olanı silin ve yeni bir görüntü yükleyin',
      ko: '참고: 슬라이더 이미지를 변경하려면 기존 이미지를 삭제하고 새 이미지를 업로드하세요',
      vi: 'Lưu ý: Để thay đổi hình ảnh thanh trượt, hãy xóa hình ảnh hiện tại và tải lên hình ảnh mới',
      id: 'Catatan: Untuk mengganti gambar slider, hapus yang sudah ada dan unggah gambar baru',
      th: 'หมายเหตุ: ในการเปลี่ยนภาพสไลด์ ให้ลบภาพที่มีอยู่และอัปโหลดภาพใหม่',
      ms: 'Nota: Untuk menukar imej gelangsar, padamkan imej sedia ada dan muat naik imej baharu',
      ar_eg: 'ملحوظة: لتغيير صورة الشريط المنزلق، احذف الصورة الحالية وقم بتحميل صورة جديدة',
      uk: 'Примітка: Щоб змінити зображення слайдера, видаліть існуюче та завантажте нове зображення',
    },
  },
  video: {
    single_upload: {
      en: 'Upload Video',
      es: 'Subir Video',
      fr: 'Télécharger la vidéo',
      de: 'Video hochladen',
      pt: 'Carregar Vídeo',
      pl: 'Prześlij wideo',
      nl: 'Video uploaden',
      el: 'Μεταφόρτωση βίντεο',
      cs: 'Nahrát video',
      sv: 'Ladda upp video',
      hu: 'Videó feltöltése',
      da: 'Upload video',
      fi: 'Lataa video',
      sk: 'Nahrať video',
      bg: 'Качване на видео',
      hr: 'Prenesi video',
      lt: 'Įkelti vaizdo įrašą',
      lv: 'Augšupielādēt video',
      et: 'Laadi video üles',
      sl: 'Naloži video',
      ga: 'Uaslódáil Físeán',
      mt: "Ittella' Vidjo",
      cy: 'Llwytho Fideo',
      ro: 'Încărcați videoclipul',
      it: 'Carica video',
      zh_cn: '上传视频',
      hi: 'वीडियो अपलोड करें',
      ar: 'تحميل الفيديو',
      bn: 'ভিডিও আপলোড করুন',
      ru: 'Загрузить видео',
      ja: 'ビデオをアップロード',
      tr: 'Video Yükle',
      ko: '비디오 업로드',
      vi: 'Tải video lên',
      id: 'Unggah video',
      th: 'อัปโหลดวิดีโอ',
      ms: 'Muat naik video',
      ar_eg: 'تحميل الفيديو',
      uk: 'Завантажити відео',
    },
    replace: {
      en: 'Replace Video',
      es: 'Reemplazar Video',
      fr: 'Remplacer la vidéo',
      de: 'Video ersetzen',
      pt: 'Substituir Vídeo',
      pl: 'Zastąp wideo',
      nl: 'Video vervangen',
      el: 'Αντικατάσταση βίντεο',
      cs: 'Nahradit video',
      sv: 'Ersätt video',
      hu: 'Videó cseréje',
      da: 'Erstat video',
      fi: 'Korvaa video',
      sk: 'Nahradiť video',
      bg: 'Замяна на видеото',
      hr: 'Zamijeni video',
      lt: 'Pakeisti vaizdo įrašą',
      lv: 'Aizstāt video',
      et: 'Asenda video',
      sl: 'Zamenjaj video',
      ga: 'Ionadaigh Físeán',
      mt: 'Ibdel il-vidjo',
      cy: 'Amnewid Fideo',
      ro: 'Înlocuiți videoclipul',
      it: 'Sostituisci video',
      zh_cn: '替换视频',
      hi: 'वीडियो बदलें',
      ar: 'استبدال الفيديو',
      bn: 'ভিডিও প্রতিস্থাপন করুন',
      ru: 'Заменить видео',
      ja: 'ビデオを置き換える',
      tr: 'Videoyu Değiştir',
      ko: '비디오 교체',
      vi: 'Thay thế video',
      id: 'Ganti video',
      th: 'แทนที่วิดีโอ',
      ms: 'Gantikan video',
      ar_eg: 'استبدال الفيديو',
      uk: 'Замінити відео',
    },
    hint: {
      en: 'Upload MP4 video, Max size of 10MB',
      es: 'Subir video MP4, Tamaño máximo de 10MB',
      fr: 'Télécharger une vidéo MP4, Taille maximale de 10MB',
      de: 'MP4-Video hochladen, Maximalgröße 10MB',
      pt: 'Carregar vídeo MP4, Tamanho máximo de 10MB',
      pl: 'Prześlij wideo MP4, Maksymalny rozmiar 10MB',
      nl: 'Upload MP4-video, Maximale grootte van 10MB',
      el: 'Μεταφόρτωση βίντεο MP4, Μέγιστο μέγεθος 10MB',
      cs: 'Nahrát video MP4, Maximální velikost 10MB',
      sv: 'Ladda upp MP4-video, Maxstorlek 10MB',
      hu: 'MP4 videó feltöltése, Max méret 10MB',
      da: 'Upload MP4-video, Maksimal størrelse 10MB',
      fi: 'Lataa MP4-video, Maksimikoko 10MB',
      sk: 'Nahrať video MP4, Maximálna veľkosť 10MB',
      bg: 'Качване на видео MP4, Максимален размер 10MB',
      hr: 'Prenesi MP4 video, Maksimalna veličina 10MB',
      lt: 'Įkelkite MP4 vaizdo įrašą, Maksimalus dydis 10MB',
      lv: 'Augšupielādējiet MP4 video, Maksimālais izmērs 10MB',
      et: 'Laadi üles MP4-video, Maksimaalne suurus 10MB',
      sl: 'Naloži MP4 video, Največja velikost 10MB',
      ga: 'Uaslódáil físeán MP4, Méid uasta 10MB',
      mt: "Ittella' vidjo MP4, Daqs massimu ta' 10MB",
      cy: 'Llwytho fideo MP4, Maint mwyaf 10MB',
      ro: 'Încărcați videoclip MP4, Dimensiune maximă de 10MB',
      it: 'Carica video MP4, Dimensione massima di 10MB',
      zh_cn: '上传 MP4 视频，最大大小为 10MB',
      hi: 'MP4 वीडियो अपलोड करें, अधिकतम आकार 10MB',
      ar: 'تحميل فيديو MP4، الحد الأقصى للحجم 10MB',
      bn: 'MP4 ভিডিও আপলোড করুন, সর্বাধিক আকার 10MB',
      ru: 'Загрузить видео MP4, Максимальный размер 10MB',
      ja: 'MP4ビデオをアップロード、最大サイズは10MB',
      tr: 'MP4 video yükleyin, Maksimum boyut 10MB',
      ko: 'MP4 비디오 업로드, 최대 크기 10MB',
      vi: 'Tải video MP4 lên, Kích thước tối đa 10MB',
      id: 'Unggah video MP4, Ukuran maksimum 10MB',
      th: 'อัปโหลดวิดีโอ MP4, ขนาดสูงสุด 10MB',
      ms: 'Muat naik video MP4, Saiz maksimum 10MB',
      ar_eg: 'تحميل فيديو MP4، الحد الأقصى للحجم 10MB',
      uk: 'Завантажте відео MP4, Максимальний розмір 10MB',
    },
    error: {
      en: 'Invalid Video Format or Size!\n Please upload in MP4 format and under size limit 10MB',
      es: '¡Formato o tamaño de video no válido!\n Por favor, sube un video en formato MP4 y dentro del límite de tamaño de 10MB',
      fr: 'Format ou taille de vidéo invalide!\n Veuillez télécharger une vidéo au format MP4 et dans la limite de taille de 10MB',
      de: 'Ungültiges Videoformat oder Größe!\n Bitte laden Sie das Video im MP4-Format und unter der Größenbeschränkung von 10MB hoch',
      pt: 'Formato ou tamanho de vídeo inválido!\n Por favor, carregue um vídeo no formato MP4 e com tamanho inferior a 10MB',
      pl: 'Nieprawidłowy format lub rozmiar wideo!\n Prześlij wideo w formacie MP4 i poniżej limitu rozmiaru 10MB',
      nl: 'Ongeldig videoformaat of -grootte!\n Upload een MP4-video onder de grootte van 10MB',
      el: 'Μη έγκυρη μορφή ή μέγεθος βίντεο!\n Παρακαλώ ανεβάστε σε μορφή MP4 και εντός του ορίου μεγέθους 10MB',
      cs: 'Neplatný formát nebo velikost videa!\n Nahrajte prosím video ve formátu MP4 a pod velikostní limit 10MB',
      sv: 'Ogiltigt videoformat eller storlek!\n Ladda upp en video i MP4-format och under storleksgränsen 10MB',
      hu: 'Érvénytelen videóformátum vagy méret!\n Kérjük, töltsön fel MP4 formátumú videót 10MB méretkorlát alatt',
      da: 'Ugyldigt videoformat eller størrelse!\n Upload venligst i MP4-format og under størrelsesgrænsen på 10MB',
      fi: 'Virheellinen videon formaatti tai koko!\n Lataa MP4-muodossa oleva video, joka on alle 10MB',
      sk: 'Neplatný formát alebo veľkosť videa!\n Nahrajte video vo formáte MP4 a do veľkostného limitu 10MB',
      bg: 'Невалиден формат или размер на видеото!\n Моля, качете видео във формат MP4 и с размер до 10MB',
      hr: 'Nevažeći format videa ili veličina!\n Molimo prenesite video u MP4 formatu i ispod ograničenja veličine od 10MB',
      lt: 'Netinkamas vaizdo įrašo formatas arba dydis!\n Įkelkite MP4 formato vaizdo įrašą ir mažesnį nei 10MB',
      lv: 'Nederīgs video formāts vai izmērs!\n Lūdzu, augšupielādējiet MP4 formātā un ievērojiet 10MB izmēra ierobežojumu',
      et: 'Vigane video formaat või suurus!\n Palun laadige üles MP4-vormingus video, mis on väiksem kui 10MB',
      sl: 'Neveljaven format videa ali velikost!\n Prosimo, naložite video v MP4 formatu in pod omejitvijo velikosti 10MB',
      ga: 'Formáid nó méid físeáin neamhbhailí!\n Uaslódáil i bhformáid MP4 agus faoi theorainn mhéide 10MB le do thoil',
      mt: "Format jew daqs tal-vidjo invalidu!\n Jekk jogħġbok ittella' vidjo f'format MP4 u taħt il-limitu ta' daqs ta' 10MB",
      cy: 'Fformat neu faint fideo annilys!\n Llwythwch i fyny mewn fformat MP4 a dan y terfyn maint o 10MB',
      ro: 'Format sau dimensiune video nevalidă!\n Vă rugăm să încărcați un videoclip în format MP4 și sub limita de dimensiune de 10MB',
      it: 'Formato o dimensione del video non valido!\n Carica un video in formato MP4 e sotto il limite di 10MB',
      zh_cn: '无效的视频格式或大小！\n 请上传MP4格式的视频，且大小低于10MB',
      hi: 'अमान्य वीडियो प्रारूप या आकार!\n कृपया MP4 प्रारूप में वीडियो अपलोड करें और 10MB के आकार सीमा के भीतर',
      ar: 'تنسيق الفيديو أو الحجم غير صالح!\n يرجى تحميل الفيديو بتنسيق MP4 وضمن الحد الأقصى للحجم 10MB',
      bn: 'অবৈধ ভিডিও ফরম্যাট বা আকার!\n অনুগ্রহ করে MP4 ফরম্যাটে এবং 10MB আকারের সীমার মধ্যে আপলোড করুন',
      ru: 'Неверный формат видео или размер!\n Пожалуйста, загрузите видео в формате MP4 и меньше 10MB',
      ja: '無効なビデオフォーマットまたはサイズです！\n MP4フォーマットでサイズ制限10MB以内でアップロードしてください',
      tr: "Geçersiz Video Formatı veya Boyutu!\n Lütfen MP4 formatında ve boyut sınırı 10MB'nin altında yükleyin",
      ko: '유효하지 않은 비디오 형식 또는 크기입니다!\n MP4 형식으로 업로드하고 크기는 10MB 이하로 해주세요',
      vi: 'Định dạng hoặc kích thước video không hợp lệ!\n Vui lòng tải lên ở định dạng MP4 và dưới giới hạn kích thước 10MB',
      id: 'Format atau ukuran video tidak valid!\n Harap unggah dalam format MP4 dan di bawah batas ukuran 10MB',
      th: 'รูปแบบหรือขนาดวิดีโอไม่ถูกต้อง!\n กรุณาอัปโหลดในรูปแบบ MP4 และต่ำกว่าขีดจำกัดขนาด 10MB',
      ms: 'Format atau saiz video tidak sah!\n Sila muat naik dalam format MP4 dan di bawah had saiz 10MB',
      ar_eg: 'تنسيق الفيديو أو الحجم غير صالح!\n يرجى تحميل الفيديو بتنسيق MP4 وأقل من 10MB',
      uk: 'Недійсний формат або розмір відео!\n Завантажте відео у форматі MP4 та менше 10MB',
    },
  },
}
export default translate
